export default __webpack_public_path__ + "static/media/Helm of Intricate Spite.9f52f085.jpg";